import React from "react";

export const initialContextValue = {
  user: {
    id: null,
    email: null,
    username: null,
    facebookUid: null,
    profileSlug: null,
    avatar: null,
    timestamp: null,
    variant: null,
  },
  isUserSignedIn: false,
  isFetching: false,
};

const AuthContext = React.createContext(initialContextValue);

export default AuthContext;
